module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Cutting board-6ce9c01f7263dfa7acd47a1518270105.svg";